import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductDetailReducer } from '@grandvisionhq/fun-products';
import { getVariantInfo } from '../../helpers.js';

const ProductDetailContext = /*#__PURE__*/ React.createContext({});
const useProductDetailContext = ()=>React.useContext(ProductDetailContext)
;
var ProductDetailProvider = (_param)=>{
    var { children , product , locale , sku , productType , renderAddToCartButton , reimbursableLogos  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "product",
        "locale",
        "sku",
        "productType",
        "renderAddToCartButton",
        "reimbursableLogos"
    ]);
    const [state, dispatch] = React.useReducer(ProductDetailReducer.productDetailContextReducer, swcHelpers.objectSpread({}, ProductDetailReducer.initialState, {
        activeSku: sku
    }));
    const activeVariant = React.useMemo(()=>getVariantInfo(product, productType, locale, state.activeSku)
    , [
        locale,
        product,
        productType,
        state.activeSku
    ]);
    const value = swcHelpers.objectSpread({}, state, {
        activeVariant,
        dispatch,
        product,
        productType,
        renderAddToCartButton,
        reimbursableLogos
    }, rest);
    return /*#__PURE__*/ React.createElement(ProductDetailContext.Provider, {
        value: value
    }, children);
};

export { ProductDetailContext, ProductDetailProvider, useProductDetailContext };
//# sourceMappingURL=ProductDetailContext.js.map
